var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopySmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40234 4.8V15.6C8.40234 16.0774 8.59199 16.5352 8.92955 16.8728C9.26712 17.2104 9.72495 17.4 10.2023 17.4H17.4023C17.8797 17.4 18.3376 17.2104 18.6751 16.8728C19.0127 16.5352 19.2023 16.0774 19.2023 15.6V7.7178C19.2023 7.478 19.1544 7.24063 19.0613 7.01962C18.9683 6.79861 18.832 6.59842 18.6605 6.4308L15.677 3.513C15.3408 3.18419 14.8892 3.00006 14.4188 3H10.2023C9.72495 3 9.26712 3.18964 8.92955 3.52721C8.59199 3.86477 8.40234 4.32261 8.40234 4.8V4.8Z",
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6008 17.4V19.2C15.6008 19.6774 15.4111 20.1352 15.0736 20.4728C14.736 20.8104 14.2782 21 13.8008 21H6.60078C6.12339 21 5.66555 20.8104 5.32799 20.4728C4.99042 20.1352 4.80078 19.6774 4.80078 19.2V9.3C4.80078 8.82261 4.99042 8.36477 5.32799 8.02721C5.66555 7.68964 6.12339 7.5 6.60078 7.5H8.40078",
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySmall);
export default __webpack_public_path__ + "static/media/copy-small.93e9404a.svg";
export { ForwardRef as ReactComponent };